import Http from 'axios';

export default {
    namespaced: true,

    state: {
        items: [],
        isOpen: false,
    },

    mutations: {
        setOpenState(state, open) {
            if(open) {
                document.body.classList.add('js-active');
            } else {
                document.body.classList.remove('js-active');
            }

            state.isOpen = open;
        },

        setItems(state, items) {
            state.items = items;
        },
    },

    actions: {
        loadData({ commit }) {
            return Http.get('/api/structure').then(res => {
                commit('setItems', res.data);
            });
        },

        open({ commit }) {
            commit('setOpenState', true);
        },

        close({ commit }) {
            commit('setOpenState', false);
        },

        toggle({ commit, state }) {
            commit('setOpenState', !state.isOpen );
        }
    }
}


// WEBPACK FOOTER //
// ../default-js/js/store/modules/navigation.js